import { apiClient } from '../../api/fetchClient';
import type {
  CheckAuthenticationRequest,
  CheckAuthenticationResponse,
  CustomerResponse,
} from '../models/auth.model';

const ID_STORAGE_KEY = 'single_customer_id';
const EMAIL_STORAGE_KEY = 'single_customer_email';

class CustomerAuthService {
  checkAuthentication(request: CheckAuthenticationRequest): Promise<CheckAuthenticationResponse> {
    const url = new URL('/apps/single/v3/authentication', window.location.origin);

    return apiClient
      .post<CheckAuthenticationResponse>(url.pathname + url.search, request)
      .then((data) => data);
  }

  async initializeCustomer(): Promise<CustomerResponse> {
    const url = new URL('/apps/single/v3/order-status/customer-data', window.location.origin);
    const customerData = await apiClient.get<CustomerResponse>(url.pathname + url.search);

    if (customerData?.customerId) {
      localStorage.setItem(ID_STORAGE_KEY, customerData.customerId);
    } else {
      localStorage.removeItem(ID_STORAGE_KEY);
    }
    if (customerData?.email) {
      localStorage.setItem(EMAIL_STORAGE_KEY, customerData.email);
    } else {
      localStorage.removeItem(EMAIL_STORAGE_KEY);
    }
    return customerData;
  }

  clearCustomer(): void {
    localStorage.removeItem(ID_STORAGE_KEY);
    localStorage.removeItem(EMAIL_STORAGE_KEY);
  }
}

export const customerAuthService = new CustomerAuthService();
